import React from 'react'
import { IconSVGType } from '../../../types/icons'

/**
 * @param {IconSVGType} props
 */
const FilePDFIcon = (props: IconSVGType) => {
  return (
    <svg
      className={props.className}
      fill='none'
      height={props.height}
      viewBox={props.viewBox || '0 0 24 24'}
      width={props.width}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fill='#5D5D5D'
        fillRule='evenodd'
        d='M4.01 4c0-1.1.89-2 1.99-2h7.17c.53 0 1.04.21 1.41.59l4.83 4.83c.38.37.59.88.59 1.41V20c0 1.1-.9 2-2 2H5.99C4.89 22 4 21.1 4 20l.01-16ZM13 3.5V8c0 .55.45 1 1 1h4.5L13 3.5ZM7.273 17H5.768v-4.9h1.869c1.21 0 2.037.56 2.037 1.729v.042c0 1.211-.91 1.771-2.023 1.771h-.378V17Zm0-3.668v1.169h.3c.358 0 .61-.189.61-.567v-.028c0-.385-.231-.574-.602-.574h-.308ZM11.7 17h-1.61v-4.9h1.645c1.736 0 2.604.917 2.604 2.373v.105c0 1.456-.882 2.422-2.639 2.422Zm1.106-2.499c0-.777-.406-1.064-1.029-1.064h-.175v2.226h.175c.623 0 1.03-.294 1.03-1.064v-.098ZM16.364 17h-1.512v-4.9h3.514v1.33h-2.002v.644h1.848v1.232h-1.848V17Z'
        clipRule='evenodd'
      />
    </svg>
  )
}

export default FilePDFIcon
